import { render, staticRenderFns } from "./twoyears.vue?vue&type=template&id=148a8928&"
import script from "./twoyears.vue?vue&type=script&lang=js&"
export * from "./twoyears.vue?vue&type=script&lang=js&"
import style0 from "./twoyears.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports